import { Image } from 'antd-mobile'
import React, { useEffect, useState } from 'react'
import AllPrice from './allprice/AllPrice'
import general, { redux } from '../../../general'
import { useScroll } from 'ahooks'
import $ from 'jquery'
import Dialog from '../../../lib/Dialog'

export default function ModifyPrice(props) {

  const [visible, setVisible] = useState(false)
  const [list, setList] = useState([])
  const [trade, setTrade] = useState({})
  const [page, setPage] = useState(1)
  const [more, setMore] = useState(true)
  const [init, setInit] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props.active && list.length > 0) {
      redux.subscribe(() => {
        const state = redux.getState()
        if (state.current_price) {
          const updatedTrades = list.map(trade => {
            // 找到目标 trade_id
            if (trade.trade_id == state.trade_id) {
              // 返回一个新对象，保留原有属性，只修改 price
              return { ...trade, sell_price: state.current_price };
            }
            // 对于不匹配的 trade，返回原对象
            return trade;
          });
          // 使用 setTrades 更新状态，这将触发组件重新渲染
          setList(updatedTrades);
        }
      })
    }

  }, [props.active, list])

  const scroll = useScroll()
  useEffect(() => {
    if (props.active && init) {
      if (scroll.top < -80) {
        getData({ page: 1 });
      }

      if (scroll.top + window.innerHeight + 20 > $(document).height() && more) {
        getData({ page: page + 1 });
      }
    }
  }, [props.active, scroll])

  const getData = (params = {}) => {
    if (loading) {
      return
    }
    setLoading(true)
    Dialog.loading()
    general.axios.post('/bargainTradeGather', {
      trade_id: props.query.id,
      pagination: {
        page: params.page,
        count: 10
      }
    })
      .finally(() => {
        Dialog.close()
      })
      .then(res => {
        const { status, data } = res.data
        if (status.succeed) {
          setLoading(false)
          setInit(true);
          params.page && setPage(params.page);
          setMore(data.paginated.more && data.main_list.length > 0);
          setList(params.page == 1 ? data.main_list : [...list, ...data.main_list]);
          if (data.main_list.length > 0) {
            if (data.main_list[0].trade_id == props.query.id) {
              setTrade(data.main_list[0])
              setVisible(true)
            }
          }
        } else {
          Dialog.error(status.error_desc)
        }
      })
  }

  useEffect(() => {
    if (props.active) {
      getData({ page: 1 })
    }
  }, [props.active])

  return (
    <div className='modifyPrice-index'>
      {list.length > 0 && <div className="list">
        {list.map(item => {
          return (
            <div className="item">
              <div className="game">
                <Image className='game-image' src={item.game_image}></Image>
                <div className="content">
                  <div className="name">
                    <span className='gamename'>{item.game_name}</span>
                    {item.nameRemark && <span className='nameremark'>{item.nameRemark}</span>}
                  </div>
                  <div className="desc">区服：{item.server_name}</div>
                  <div className="desc">价格：￥{item.sell_price}</div>
                </div>
              </div>
              <div className="prices">
                <div className="number">共{item.bidders_number}人出价</div>
                <div className="all" onClick={() => {
                  setVisible(true)
                  setTrade(item)
                }}>全部出价</div>
              </div>
            </div>
          )
        })}
      </div>}
      {init && list.length == 0 && <div className="empty"><img className='icon' src="/resources/empty.png" alt=""/>暂无数据</div>}
      <AllPrice trade={trade} handleDismiss={() => setVisible(false)} visible={visible}></AllPrice>
    </div>
  )
}
